import { MobileModel, ConsultCookieName, ConsultQueryName, MessageType, MessageMsgFrom } from '@tencent/dz-models';
import PhoneNumber from '@tencent/bricks-components/lib/PhoneNumber';
import { ModuleParams } from '@tencent/dz-report';
import { ImpCoreModel } from './ImpCoreMode';
import Cookies from 'js-cookie';
import { report, logger } from 'src/helper';

export class ImpMobileModel extends MobileModel {
  coreModel: ImpCoreModel;

  private MOBILE_EXPIRES = 60 * 60 * 24 * 10;

  constructor(coreModel: ImpCoreModel) {
    super();
    this.coreModel = coreModel;
  }

  getState() {}

  async fetchPhoneNumber() {
    const consultModel = this.coreModel.getConsultModel();

    const params = {
      // 广告点击id，广点通填写qz_gdt的值，微信广告gdt_vid
      traceId: consultModel.traceID,
      // 分配的业务id
      businessId: 'landing_page_leads',
      advertiserId: consultModel.uid,
      //   环境变量：test(测试，默认值)；production(生产)
      env: 'test',
    };

    const phoneInstance = new PhoneNumber(params);

    const reporCommonParams = {
      module_type: 'page_initialization',
      module_chinese_type: '页面初始化',
      module_value: '',
      element_id: '',
    };
    const startTime = new Date().getTime();
    report.exposure({
      ...reporCommonParams,
      element_type: 'get_phone_number',
      element_chinese_type: '获取手机号',
    });

    const carrier = ['默认', '移动', '联通', '电信'];
    const nav: any = navigator;
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
    const connectionType = connection ? connection.type : '';

    phoneInstance.getNumber()
      .then((data: any) => {
        const { mobile, encryptPhone, carrierType } = data;
        const endTime = new Date().getTime();
        if (mobile !== '***********') {
          this.mobile = mobile;
          this.carrierType = Number(carrierType) || 0;
          this.encryptPhone = encryptPhone;
          this.autoPhoneEnabled = true;
          Cookies.set(ConsultCookieName.Mobile, mobile, { expires: this.MOBILE_EXPIRES });
          Cookies.set(ConsultCookieName.Carrier_Type, carrierType, { expires: this.MOBILE_EXPIRES });
          Cookies.set(ConsultCookieName.Encrypt_Phone, encryptPhone, { expires: this.MOBILE_EXPIRES });
        }

        report.exposure({
          ...reporCommonParams,
          element_type: 'get_phone_number_result',
          element_chinese_type: '获取手机号_业务结果',
          element_content: `${carrier[carrierType]}^${connectionType || ''}`,
        });
        report.api({
          api_name: 'sdk/getPhoneNumber',
          http_code: 200,
          api_cost: endTime - startTime,
          api_result: '1', // 1-成功；2-失败
        });
      })
      .catch((error: any) => {
        // log
        const endTime = new Date().getTime();
        report.exposure({
          ...reporCommonParams,
          element_id: error.code,
          element_type: 'get_phone_number_fail',
          element_chinese_type: '获取手机号_异常',
          element_content: `${error.msg}^${connectionType || ''}`,
        });

        report.api({
          api_name: 'sdk/getPhoneNumber',
          api_cost: endTime - startTime,
          api_result: '2', // 1-成功；2-失败
        });
      });
  }

  async callByComponentId(componentId: string, moduleParams: ModuleParams) {
    const consultModel = this.coreModel.getConsultModel();
    const messageModel = this.coreModel.getMessageModel();

    const url = consultModel.hitTheGray ? '/viewer/consult/get_tel' : 'custom/consult/gettel';

    const telRes = await this.coreModel.request.get<{ full_number: string}>(url, {
      params: {
        chat_id: messageModel.chatInfo?.chat_id || '',
        consult_id: consultModel.getConsultConfig().consult_id,
        u_id: consultModel.consult.u_id,
        click_id: consultModel.clickID,
        component_id: componentId,
        page_id: consultModel.getQueryParams(ConsultQueryName.Page_Id),
        app_id: consultModel.getQueryParams(ConsultQueryName.App_Id),
      },
      updateRemoteCiTokenFail: () => {
        this.reportTellError(componentId, moduleParams);
      },
    });
    if (telRes.code !== 0) {
      this.reportTellError(componentId, moduleParams);
      return logger.error('gettel error', telRes);
    }
    const { data: telData } = telRes;
    messageModel.pushMessage({
      type: MessageType.SystemCustom,
      msg_from: MessageMsgFrom.Server,
      payload: {
        message: '欢迎致电',
      },
    });

    if (moduleParams) {
      report.click({
        ...moduleParams,
        element_id: componentId,
        element_type: 'phone',
        element_chinese_type: '电话组件',
        element_content: telData.full_number,
      });
    }

    // 拨打电话
    consultModel.transferMessage(JSON.stringify({
      type: 'tel',
      url: telData.full_number,
    }), () => (window.location.href = `tel:${telData.full_number}`));
  }

  // 是否获取手机号
  public getPhoneNumberVerification() {
    if (this.isValidPhoneNumber()) {
      this.autoPhoneEnabled = true;
    } else {
      this.fetchPhoneNumber();
    }
  }

  private reportTellError(componentId?: string, moduleParams?: ModuleParams) {
    if (componentId && moduleParams) {
      report.click({
        ...moduleParams,
        element_id: componentId,
        element_type: 'phone_fail',
        element_chinese_type: '电话组件_拨打失败',
        element_content: '',
      });
    }
  };
}
